import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "recover-condition"
};
const _hoisted_2 = {
  class: "btn-group"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "btn-group"
};
import { onMounted, ref, toRefs, reactive, watch } from 'vue';
import { mctRequest } from '@/api/axios';
import { ElMessage } from 'element-plus';
import { differenceInMinutes } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
import { useMaintainStore } from '@/store/maintain';
export default /*@__PURE__*/_defineComponent({
  __name: 'MaintainZone',
  props: {
    maintainedId: {},
    maintainedLevel: {}
  },
  setup(__props) {
    const store = useUserDefaultSettingStore();
    const {
      timeZone,
      userCEC,
      timeZoneArea
    } = storeToRefs(store);
    const maintainStore = useMaintainStore();
    const {
      isShowMaintainDialog
    } = storeToRefs(maintainStore);
    const props = __props;
    const {
      maintainedId,
      maintainedLevel
    } = toRefs(props);
    const maintainZoneRef = ref();
    const maintainForm = reactive({
      id: 0,
      selectedAgents: [],
      name: '',
      status: 2,
      time: '',
      isTicketDone: true,
      memo: '',
      ticketnum: ''
    });
    const rules = reactive({
      selectedAgents: [{
        required: true,
        message: 'Please select',
        trigger: 'change'
      }],
      memo: [{
        required: true,
        message: 'Please input the description',
        trigger: 'blur'
      }]
    });
    const agents = ref([]);
    const autoRecoverRadio = ref(2);
    const autoRecoverTime = ref('');
    const autoRecoverDuration = ref();
    const autoRecoverDurationOptions = [{
      value: '30',
      label: '0.5 hour'
    }, {
      value: '60',
      label: '1 hour'
    }, {
      value: '120',
      label: '2 hour'
    }, {
      value: '180',
      label: '3 hour'
    }, {
      value: '240',
      label: '4 hour'
    }, {
      value: '300',
      label: '5 hour'
    }, {
      value: '360',
      label: '6 hour'
    }, {
      value: '1440',
      label: '1 day'
    }, {
      value: '2880',
      label: '2 days'
    }, {
      value: '4320',
      label: '3 days'
    }, {
      value: '999999',
      label: 'Never'
    }];
    const getMaintainZone = async () => {
      if (maintainedLevel.value === 'Zone') {
        const config = {
          url: `/zone/getZoneById/${maintainedId.value}`
        };
        const {
          singleZone
        } = await mctRequest.request(config);
        maintainForm.id = singleZone.zoneId;
        maintainForm.name = singleZone.zoneName;
      } else if (maintainedLevel.value === 'Cluster') {
        agents.value = [];
        maintainForm.selectedAgents = [];
        const config = {
          url: `/zone/getZones/${maintainedId.value}`
        };
        const {
          zoneList
        } = await mctRequest.request(config);
        zoneList.map(check => {
          const item = {
            label: check.zoneName,
            value: check.zoneId
          };
          agents.value.push(item);
        });
      }
    };
    const validateForm = async () => {
      if (!maintainZoneRef.value) return;
      await maintainZoneRef.value.validate(valid => {
        if (autoRecoverRadio.value === 2 && autoRecoverDuration.value === '999999' && !maintainForm.ticketnum) {
          ElMessage({
            type: 'error',
            message: 'Auto recover cannot be never if there is no ticket number'
          });
        } else if (valid) {
          handleMaintenance();
        }
      });
    };
    const handleMaintenance = async () => {
      maintainForm.time = formatInTimeZone(new Date(), timeZoneArea.value, 'yyyy-MM-dd HH:mm:ss');
      const duration = autoRecoverRadio.value === 1 ?
      // @ts-ignore
      differenceInMinutes(new Date(autoRecoverTime.value), new Date(maintainForm.time)) : autoRecoverDuration.value || 1440;
      const CommonMaintainList = [];
      if (maintainedLevel.value === 'Cluster') {
        maintainForm.selectedAgents?.map(item => {
          CommonMaintainList.push({
            forceMaintain: 1,
            id: item,
            memo: maintainForm.memo,
            recover: duration,
            status: maintainForm.status,
            ticketnum: maintainForm.ticketnum,
            time: maintainForm.time,
            // type is 2 when maintain level is zone
            type: 2,
            username: userCEC.value
          });
        });
      } else {
        CommonMaintainList.push({
          forceMaintain: 1,
          id: maintainForm.id,
          memo: maintainForm.memo,
          recover: Number(duration),
          status: maintainForm.status,
          ticketnum: maintainForm.ticketnum,
          time: maintainForm.time,
          // type is 2 when maintain level is zone
          type: 2,
          username: userCEC.value
        });
      }
      const config = {
        url: `/maintain/update/int/${timeZone.value}`,
        method: 'post',
        data: {
          CommonMaintainList
        }
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'Maintain Successfully'
      });
      if (!maintainForm.ticketnum) {
        ElMessage({
          type: 'warning',
          message: 'Use a default ticket number since it was not provided'
        });
      }
      // init()
      isShowMaintainDialog.value = false;
    };
    const unMaintainZoneTableRef = ref();
    const multipleSelection = ref([]);
    const unMaintainZoneTableData = ref([]);
    const getUnMaintainZone = async () => {
      const config = {
        url: `/maintain/query/2/${maintainedId.value}`
      };
      const {
        commonMaintains
      } = await mctRequest.request(config);
      unMaintainZoneTableData.value = commonMaintains;
    };
    const handleSelectionChange = val => {
      multipleSelection.value = val;
    };
    const handleUnMaintain = async () => {
      if (!multipleSelection.value?.length) {
        ElMessage({
          type: 'error',
          message: 'Please select at least one zone!'
        });
        return;
      }
      const config = {
        url: `/maintain/update/int/${timeZone.value}`,
        method: 'post',
        data: {
          CommonMaintainList: multipleSelection.value,
          onlyRecover: true
        }
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'UnMaintain Successfully'
      });
      init();
    };
    const init = () => {
      getMaintainZone();
      getUnMaintainZone();
    };
    const clearDialog = () => {
      maintainZoneRef.value?.resetFields();
      autoRecoverRadio.value = 2;
      autoRecoverTime.value = '';
      autoRecoverDuration.value = '1440';
    };
    watch(isShowMaintainDialog, () => {
      if (isShowMaintainDialog.value) {
        init();
      } else {
        clearDialog();
      }
    });
    onMounted(() => {
      init();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", null, [_cache[19] || (_cache[19] = _createElementVNode("h2", {
        class: "maintain-title"
      }, "Maintain Zone", -1)), _createVNode(_component_el_form, {
        class: "maintain-form",
        ref_key: "maintainZoneRef",
        ref: maintainZoneRef,
        model: maintainForm,
        rules: rules,
        "label-position": "top",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [_unref(maintainedLevel) === 'Cluster' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          prop: "selectedAgents",
          label: "Target Zone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: maintainForm.selectedAgents,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => maintainForm.selectedAgents = $event),
            filterable: "",
            multiple: "",
            placeholder: "Select",
            style: {
              "width": "240px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agents.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _unref(maintainedLevel) === 'Zone' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "Name",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: maintainForm.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => maintainForm.name = $event),
            disabled: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "Maintain",
          prop: "status"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: maintainForm.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => maintainForm.status = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: 1
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("Offline")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: 2
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("Maintain")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Recover Condition"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_checkbox, {
            modelValue: maintainForm.isTicketDone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => maintainForm.isTicketDone = $event),
            disabled: ""
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode(" Ticket done ")])),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Auto Recover"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: autoRecoverRadio.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => autoRecoverRadio.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: 1
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                placeholder: "Select Date and Time",
                modelValue: autoRecoverTime.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => autoRecoverTime.value = $event),
                type: "datetime"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: 2
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: autoRecoverDuration.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => autoRecoverDuration.value = $event),
                class: "m-2",
                placeholder: "1 Day"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(autoRecoverDurationOptions, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Description",
          prop: "memo"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: maintainForm.memo,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => maintainForm.memo = $event),
            class: "table-input",
            placeholder: "Memo"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Ticket Number",
          prop: "ticketnum"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: maintainForm.ticketnum,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => maintainForm.ticketnum = $event),
            class: "table-input",
            placeholder: "Ticket"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        onClick: _cache[9] || (_cache[9] = $event => isShowMaintainDialog.value = false)
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("Cancel")])),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "omi-maintain-zone",
        onClick: validateForm,
        type: "success"
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode(" Submit ")])),
        _: 1
      })]), _unref(maintainedLevel) === 'Zone' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[18] || (_cache[18] = _createElementVNode("h2", {
        class: "maintain-title"
      }, "Un-Maintain Zone", -1)), _createVNode(_component_el_table, {
        ref_key: "unMaintainZoneTableRef",
        ref: unMaintainZoneTableRef,
        data: unMaintainZoneTableData.value,
        border: "",
        style: {
          "width": "100%"
        },
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name",
          width: "160"
        }), _createVNode(_component_el_table_column, {
          label: "Result"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.result_type === 0 ? 'Offline' : 'Maintain'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "Type"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.type === 3 ? 'Server' : scope.row.type === 2 ? 'Zone' : 'Cluster'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "time",
          label: "Maintain Start Time",
          width: "170"
        }), _createVNode(_component_el_table_column, {
          label: "Recover Duration",
          width: "170"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.recover + '(min)'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "Recover Condition",
          width: "170"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.forceMaintain === 1 ? 'ticket done' : scope.row.forceMaintain === 2 ? '5 polls pass' : ''), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "ticketStatus",
          label: "Status"
        }), _createVNode(_component_el_table_column, {
          prop: "username",
          label: "User"
        }), _createVNode(_component_el_table_column, {
          prop: "memo",
          label: "Reason",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "ticketnum",
          label: "Ticket Number",
          width: "170"
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        onClick: _cache[10] || (_cache[10] = $event => isShowMaintainDialog.value = false),
        class: "cancel-btn"
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode(" Cancel ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleUnMaintain
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode(" Un Maintain ")])),
        _: 1
      })])])) : _createCommentVNode("", true)]);
    };
  }
});